import { createContext } from 'react';

export const GlobalConfirmDeleteDialogContext =
  createContext<GlobalConfirmDeleteDialogContextValue>({
    open: () => {
      throw new Error(
        'no GlobalDialogDeleteContext available. Make sure you are in the the context'
      );
    }
  });

export type GlobalConfirmDeleteDialogContextValue = {
  open: <T>(opts: GlobalConfirmDeleteDialogContextOpenOptions<T>) => void;
};

export type GlobalConfirmDeleteDialogContextOpenOptions<T> = {
  item: T;
  getName: (item: T) => string;
  onDelete: (item: T) => void;
};
